import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ThankYouPage from './pages/ThankYouPage';
import FormularInscrierePage from './pages/FormularInscrierePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';
import GDPRPage from './pages/GDPRPage';
import SpeakersWidget from './components/SpeakersWidget';
import CookiePopup from './components/CookiePopup';

function App() {
  const location = useLocation();
  const scriptsLoaded = useRef({
    script: false,
    formEmbed: false
  });

  useEffect(() => {
    // Facebook Pixel tracking
    // Wait for Pixel to be ready, or use queue if not loaded yet
    const trackPixel = () => {
      if (typeof window.fbq !== 'undefined') {
        if (location.pathname === '/thank-you') {
          window.fbq('track', 'Lead');
        } else if (location.pathname === '/') {
          window.fbq('track', 'PageView');
        }
      } else {
        // If Pixel not loaded yet, wait a bit and retry
        setTimeout(trackPixel, 100);
      }
    };
    
    trackPixel();

    // Load script.js only once
    if (!scriptsLoaded.current.script && !document.querySelector('script[src="/script.js"]')) {
      const script1 = document.createElement('script');
      script1.src = '/script.js';
      script1.defer = true;
      script1.id = 'main-script';
      document.body.appendChild(script1);
      scriptsLoaded.current.script = true;
    }

    // Load form embed script only once
    if (!scriptsLoaded.current.formEmbed && !document.querySelector('script[src*="form_embed.js"]')) {
      const script2 = document.createElement('script');
      script2.src = 'https://link.kerrsid.com/js/form_embed.js';
      script2.defer = true;
      script2.id = 'form-embed-script';
      document.body.appendChild(script2);
      scriptsLoaded.current.formEmbed = true;
    }
  }, [location]);

  // Hide speakers widget on form and thank you pages
  const showSpeakersWidget = location.pathname === '/';

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/formular-inscriere" element={<FormularInscrierePage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/termeni-si-conditii" element={<TermsPage />} />
        <Route path="/politica-de-confidentialitate" element={<PrivacyPage />} />
        <Route path="/politica-cookies" element={<CookiesPage />} />
        <Route path="/gdpr" element={<GDPRPage />} />
      </Routes>
      {showSpeakersWidget && <SpeakersWidget />}
      <CookiePopup />
    </>
  );
}

export default App;

